__turbopack_context__.v({
  "arrow": "SettingsLayout-module-scss-module__LRrQ3a__arrow",
  "arrowHead": "SettingsLayout-module-scss-module__LRrQ3a__arrowHead",
  "arrowIcon": "SettingsLayout-module-scss-module__LRrQ3a__arrowIcon",
  "contentArea": "SettingsLayout-module-scss-module__LRrQ3a__contentArea",
  "divider": "SettingsLayout-module-scss-module__LRrQ3a__divider",
  "flag": "SettingsLayout-module-scss-module__LRrQ3a__flag",
  "flagWrapper": "SettingsLayout-module-scss-module__LRrQ3a__flagWrapper",
  "iconWrapper": "SettingsLayout-module-scss-module__LRrQ3a__iconWrapper",
  "languageButton": "SettingsLayout-module-scss-module__LRrQ3a__languageButton",
  "settingButton": "SettingsLayout-module-scss-module__LRrQ3a__settingButton",
  "settingText": "SettingsLayout-module-scss-module__LRrQ3a__settingText",
  "settingToggle": "SettingsLayout-module-scss-module__LRrQ3a__settingToggle",
  "settingsBar": "SettingsLayout-module-scss-module__LRrQ3a__settingsBar",
  "settingsButton": "SettingsLayout-module-scss-module__LRrQ3a__settingsButton",
  "settingsContainer": "SettingsLayout-module-scss-module__LRrQ3a__settingsContainer",
  "toggleSlider": "SettingsLayout-module-scss-module__LRrQ3a__toggleSlider",
  "toggleSwitch": "SettingsLayout-module-scss-module__LRrQ3a__toggleSwitch",
});
